import { getCurrentInstance, ref, set } from "@vue/composition-api";

export default function useUploadedFilePreview() {
  const vm = getCurrentInstance();
  const files = ref<File[]>([]);
  const addFilesFromDevice = (uploadedFiles: FileList) => {
    files.value = Array.from(uploadedFiles);
  };

  const updateUploadedFile = ({ file, index }: { file: File; index: number }) => {
    set(files.value, index, file);
  };
  const removeFileFromUploadedList = (index: number) => {
    files.value = files.value.filter((f, i) => i !== index);
  };
  const closeEditModal = () => {
    files.value = [];
  };
  const uploadFiles = (fileList: File[]) => {
    vm?.$emit("addFiles", fileList);
  };

  return {
    files,
    addFilesFromDevice,
    updateUploadedFile,
    removeFileFromUploadedList,
    closeEditModal,
    uploadFiles,
  };
}
